export default "__VITE_ASSET__6L5Ew44m__"